export default __webpack_public_path__ + "static/media/six.65d58b25.glb";